export const enum RefreshTokenErrorMessage {
  FAILED = 'Fail to refresh the token',
  SESSION_EXPIRED = 'Session is expired',
  EXPIRED = 'Refresh token is expired',
}

export class RefreshTokenError<T = unknown> extends Error {
  error: T | null;

  constructor(message?: RefreshTokenErrorMessage, error: T | null = null) {
    super(message);
    this.error = error;
  }
}
